import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=4a3833eb"
import script from "./pin.vue?vue&type=script&lang=js"
export * from "./pin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports